const manuallyEscapedMap = {
	'!': '%21',
	'\\*': '%2A',
	'\'': '%27',
	'\\(': '%28',
	'\\)': '%29',
	'~': '%7E'
};

/**
 * Escapes special characters in a query string
 * It's often sufficient to use auto-encoding of axios (eg. via setting 'params' props), but to guarantee the full
 * percent-encoding of all special characters, this function can be used, which should help to avoid further issues
 * @param query - The query string to escape.
 * @returns The escaped query string.
 */
export function escapeQueryParams(value: string) {
	let escapedQuery = encodeURIComponent(value);

	Object.entries(manuallyEscapedMap).forEach(([key, value]) => {
		escapedQuery = escapedQuery
			.replace(new RegExp(key, 'g'), value);
	});

	return escapedQuery;
}

/**
 * Prepares the search phrase by trimming and escaping query parameters.
 *
 * @param query - The search phrase to be prepared.
 * @returns The prepared search phrase.
 */
export function prepareSearchPhrase(query: string) {
	return escapeQueryParams(query.trim());
}

export function getQueryParams(search = window.location.search) {
	const params = new URLSearchParams(search);
	const queryParams: Record<string, string> = {};

	params.forEach((value, key) => {
		queryParams[key] = value;
	});

	return queryParams;
}

export function removeQueryParams(url: string): string {
    const parsedUrl = new URL(url);

    parsedUrl.search = '';

    return parsedUrl.toString();
}

export function removeDuplicateSlashes(url: string): string {
    const [protocol, rest] = url.split("://");

    const cleanedRest = rest.replace(/\/{2,}/g, '/');

    return `${protocol}://${cleanedRest}`;
}